import { MutationHookOptions, useMutation } from '@apollo/client'
import type {
  UseSendMagicLinkEmailMutation,
  UseSendMagicLinkEmailMutationVariables,
} from 'apollo-gql'

import mutation from '../graphql/mutations/sendMagicLinkEmailMutation'

type MutationFunction = ({
  email,
}: UseSendMagicLinkEmailMutationVariables) => Promise<void>

type UseSendMagicLinkEmail = (
  options?: MutationHookOptions<
    UseSendMagicLinkEmailMutation,
    UseSendMagicLinkEmailMutationVariables
  >,
) => [MutationFunction, { loading: boolean }]

const useSendMagicLinkEmail: UseSendMagicLinkEmail = (options = {}) => {
  const [mutate, { loading }] = useMutation<
    UseSendMagicLinkEmailMutation,
    UseSendMagicLinkEmailMutationVariables
  >(mutation, options)

  const sendMagicLinkEmail: MutationFunction = async ({ email }) => {
    if (!email) {
      throw new Error('email is required in sendMagicLinkEmail')
    }

    await mutate({
      variables: { email },
    })
  }

  return [sendMagicLinkEmail, { loading }]
}

export default useSendMagicLinkEmail
